export default "__VITE_ASSET__BYFv7Omi__"